import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PayrollCycle } from "./types";

export const payrollCycleListService = (params: {
  page?: number | null;
  limit?: number | null;
  ids?: string[] | null;
  type?: string;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PayrollCycle>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const payrollCycleListShortService = (params: {
  page?: number | null;
  limit?: number | null;
  ids?: string[] | null;
  type?: string;
  status?: number | null;
  keyword?: string;
}) =>
  RestAPIClient.call<RestAPIResponseList<PayrollCycle>>({
    method: HTTPRequestMethods.GET,
    url: Paths.Short,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const payrollCycleCreateService = (params: {
  type: string;
  period: number;
  from: number;
  to: number;
  cutOffDate: number;
  payDate: number;
  isPayDateNextCycle: boolean;
}) =>
  RestAPIClient.call<PayrollCycle>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const payrollCycleUpdateService = ({
  id,
  ...rest
}: Parameters<typeof payrollCycleCreateService>[0] & {
  id: string;
  status?: number;
}) =>
  RestAPIClient.call<PayrollCycle>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${String(id)}`,
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const payrollCycleDetailService = (id: string) =>
  RestAPIClient.call<PayrollCycle>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const payrollCycleActiveService = (id: string) =>
  RestAPIClient.call<PayrollCycle>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.active.replace("{id}", id)}`,
    config: {
      requireAuthentication: true,
    },
  });

export const payrollCycleInactiveService = (id: string) =>
  RestAPIClient.call<PayrollCycle>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.inactive.replace("{id}", id)}`,
    config: {
      requireAuthentication: true,
    },
  });
